// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const INCLUDES_LIMIT_TO_PERSISTENCE_KEY = {
  INCLUDES_LOWER_LIMIT: 'IncludesLowerLimit',
  INCLUDES_UPPER_LIMIT: 'IncludesUpperLimit'
} as const;

/** @see net/disy/cadenza/workbook/model/classification/IncludesLimit.java */
export type IncludesLimit = keyof typeof INCLUDES_LIMIT_TO_PERSISTENCE_KEY;

export const IncludesLimit = {
  values: Object.keys(INCLUDES_LIMIT_TO_PERSISTENCE_KEY) as readonly IncludesLimit[],
  toPersistenceKey: (value: IncludesLimit) => INCLUDES_LIMIT_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = IncludesLimit.values.find(key => INCLUDES_LIMIT_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No IncludesLimit for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
